const dedupParts = (parts) => {
  const seen = new Set();
  const out = [];
  for (const raw of parts) {
    if (raw === null || raw === undefined) continue;
    const v = String(raw).trim();
    if (!v) continue;
    const key = v.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(v);
  }
  return out;
};

const splitOnCommas = (parts) =>
  parts.flatMap((p) =>
    p === null || p === undefined ? [] : String(p).split(",")
  );

const formatAddress = (address) => {
  if (!address) return "";

  if (address.summaryline && address.summaryline.trim() !== "") {
    return dedupParts(address.summaryline.split(",")).join(", ");
  }

  return dedupParts(
    splitOnCommas([
      address.addressline1,
      address.addressline2,
      address.posttown,
      address.postcode,
    ])
  ).join(", ");
};

export { formatAddress, dedupParts };
